import { SecuritySummaryModel } from './security-summary.model';

export class ExtendedSecuritySummaryModel extends SecuritySummaryModel {
    registeredSharesPercent: number;
    dispoPercent: number;

    constructor(init: ExtendedSecuritySummaryModel) {
        super(init);
        Object.assign(this, init);
    }
}
